/* eslint-disable react/display-name */
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';

const GlobalSearch = forwardRef((props: any, ref) => {
    const [search, setSearch] = useState<any>(null);
    const [searchh, setSearchh] = useState<any>(null);

    useEffect(() => {
        const handleSearch = () => {
            if (search != null) {
                props.getSearchData(search.trim());
            }
        };

        const debounceTimer = setTimeout(() => {
            handleSearch();
        }, 1000);

        return () => clearTimeout(debounceTimer);
    }, [search]);

    const handleChange = e => {
        setSearch(e.target.value);
        setSearchh(e.target.value);
    };

    const clearSearchBox = () => {
        setSearchh('');
    };

    useImperativeHandle(ref, () => ({
        clearSearchBox,
    }));

    return (
        <>
            <div>
                <form
                    className="search_filter_box"
                    onSubmit={e => {
                        e.preventDefault();
                    }}
                >
                    <input
                        type="text"
                        placeholder={`Search here...`}
                        value={searchh || ''}
                        onChange={e => {
                            handleChange(e);
                        }}
                    />
                    <img className="search_icon img-fluid" src="assets/images/search_btn.svg" alt="" />
                </form>
                <small className='font10'>{props.helperText}</small>
            </div>
        </>
    );
});

export default GlobalSearch;
